import { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface HeaderContextType {
  headerElement: ReactNode | null;
  setHeaderElement: (element: ReactNode | null) => void;
}

const HeaderContext = createContext<HeaderContextType | null>(null);

export const HeaderProvider = ({ children }: { children: ReactNode }) => {
  const [headerElement, setHeaderElementState] = useState<ReactNode | null>(null);
  
  const setHeaderElement = useCallback((element: ReactNode | null) => {
    setHeaderElementState(element);
  }, []);

  return (
    <HeaderContext.Provider value={{ headerElement, setHeaderElement }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeaderContext must be used within HeaderProvider');
  }
  return context;
};
